import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  {path: '/login', component: () => import('@/views/login/index'), hidden: true},
  {path: '/404', component: () => import('@/views/404'), hidden: true},
  {
    path: '',
    component: Layout,
    redirect: '/home',
    children: [{
      path: 'home',
      name: 'home',
      component: () => import('@/views/home/index'),
      meta: {title: '首页', icon: 'home'}
    }]
  }
]

export const asyncRouterMap = [
  {
    path: '/umsm',
    component: Layout,
    redirect: '/umsm/member',
    name: 'umsm',
    meta: {title: '用户', icon: 'user'},
    children: [
      {
      path: 'member',
      name: 'member',
      component: () => import('@/views/umsm/member/index'),
      meta: {title: '用户列表', icon: 'product-list'}
    },
    {
      path: 'feedback',
      name: 'feedback',
      component: () => import('@/views/umsm/feedback/index'),
      meta: {title: '用户反馈', icon: 'product-list'}
    }
    ]
  },
  {
    path: '/punch',
    component: Layout,
    redirect: '/punch/log',
    name: 'punch',
    meta: {title: '打卡', icon: 'user'},
    children: [
      {
      path: 'punch',
      name: 'punch',
      component: () => import('@/views/punch/log/index'),
      meta: {title: '打卡', icon: 'product-list'}
    }
    ]
  },
  {
    path: '/tms',
    component: Layout,
    redirect: '/tms/team',
    name: 'tms',
    meta: {title: '团队', icon: 'order'},
    children: [
      {
        path: 'team',
        name: 'team',
        component: () => import('@/views/tms/team/index'),
        meta: {title: '团队列表', icon: 'product-list'}
      },
      {
        path: 'teamaudit',
        name: 'teamaudit',
        component: () => import('@/views/tms/teamaudit/index'),
        meta: {title: '团队审核', icon: 'product-list'}
      },
      {
        path: 'activity',
        name: 'activity',
        component: () => import('@/views/tms/activity/index'),
        meta: {title: '活动列表', icon: 'product-list'}
      },
      {
        path: 'activityaudit',
        name: 'activityaudit',
        component: () => import('@/views/tms/activityaudit/index'),
        meta: {title: '活动审核', icon: 'product-list'}
      }
    ]
  },
  {
    path:'/sms',
    component: Layout,
    redirect: '/sms/site',
    name: 'sms',
    meta: {title: '智慧栈', icon: 'sms'},
    children: [
      {
        path: 'site',
        name: 'site',
        component: () => import('@/views/sms/site/index'),
        meta: {title: '智慧栈列表', icon: 'sms-flash'}
      },
      {
        path: 'siteaudit',
        name: 'siteaudit',
        component: () => import('@/views/sms/siteaudit/index'),
        meta: {title: '智慧栈审核', icon: 'sms-flash'}
      },
      {
        path: 'activity',
        name: 'activity',
        component: () => import('@/views/sms/activity/index'),
        meta: {title: '活动列表', icon: 'sms-flash'}
      },
      {
        path: 'activityaudit',
        name: 'activityaudit',
        component: () => import('@/views/sms/activityaudit/index'),
        meta: {title: '活动审核', icon: 'sms-flash'}
      }
    ]
  },
  {
    path:'/bms',
    component: Layout,
    redirect: '/bms/banner',
    name: 'bms',
    meta: {title: 'banner', icon: 'order'},
    children: [
      {
        path: 'banner',
        name: 'banner',
        component: () => import('@/views/bms/banner/index'),
        meta: {title: '轮播', icon: 'product-list'}
      }
    ]
  },
  {
    path:'/ams',
    component: Layout,
    redirect: '/ams/medal',
    name: 'medal',
    meta: {title: '勋章', icon: 'order'},
    children: [
      {
        path: 'medalclass',
        name: 'medalclass',
        component: () => import('@/views/ams/medalclass/index'),
        meta: {title: '勋章分类', icon: 'product-list'}
      },
      {
        path: 'medal',
        name: 'medal',
        component: () => import('@/views/ams/medal/index'),
        meta: {title: '勋章管理', icon: 'product-list'}
      }
    ]
  },
  {
    path:'/cms',
    component: Layout,
    redirect: '/cms/certificate',
    name: 'cms',
    meta: {title: '证书管理', icon: 'order'},
    children: [
      {
        path: 'certificate',
        name: 'certificate',
        component: () => import('@/views/cms/certificate/index'),
        meta: {title: '证书生成', icon: 'product-list'}
      },
      {
        path: 'record',
        name: 'record',
        component: () => import('@/views/cms/record/index'),
        meta: {title: '生成记录', icon: 'product-list'}
      }
    ]
  },
  {
    path:'/ams',
    component: Layout,
    redirect: '/ams/shareImg',
    name: 'share',
    meta: {title: '分享', icon: 'order'},
    children: [
      {
        path: 'shareImg',
        name: 'shareImg',
        component: () => import('@/views/ams/shareImg/index'),
        meta: {title: '分享图管理', icon: 'product-list'}
      },
      {
        path: 'shareText',
        name: 'shareText',
        component: () => import('@/views/ams/shareText/index'),
        meta: {title: '分享文案管理', icon: 'product-list'}
      }
    ]
  },
  {
    path:'/ams',
    component: Layout,
    redirect: '/ams/config',
    name: 'ams',
    meta: {title: '配置', icon: 'sms'},
    children: [
      
      {
        path: 'config',
        name: 'config',
        component: () => import('@/views/ams/config/index'),
        meta: {title: '全局配置', icon: 'sms-flash'}
      },
      {
        path: 'problem',
        name: 'problem',
        component: () => import('@/views/ams/problem/index'),
        meta: {title: '常见问题', icon: 'sms-flash'}
      },
      {
        path: 'joinPath',
        name: 'joinPath',
        component: () => import('@/views/ams/joinPath/index'),
        meta: {title: '加入必经之路', icon: 'sms-flash'}
      }
    ]
  },
  {
    path:'/ums',
    component: Layout,
    redirect: '/ums/admin',
    name: 'ums',
    meta: {title: '系统', icon: 'ums'},
    children: [
      {
        path: 'admin',
        name: 'admin',
        component: () => import('@/views/ums/admin/index'),
        meta: {title: '用户列表', icon: 'ums-admin'}
      },
      {
        path: 'role',
        name: 'role',
        component: () => import('@/views/ums/role/index'),
        meta: {title: '角色列表', icon: 'ums-role'}
      },
      {
        path: 'allocMenu',
        name: 'allocMenu',
        component: () => import('@/views/ums/role/allocMenu'),
        meta: {title: '分配菜单'},
        hidden: true
      },
      {
        path: 'allocResource',
        name: 'allocResource',
        component: () => import('@/views/ums/role/allocResource'),
        meta: {title: '分配资源'},
        hidden: true
      },
      {
        path: 'menu',
        name: 'menu',
        component: () => import('@/views/ums/menu/index'),
        meta: {title: '菜单列表', icon: 'ums-menu'}
      },
      {
        path: 'addMenu',
        name: 'addMenu',
        component: () => import('@/views/ums/menu/add'),
        meta: {title: '添加菜单'},
        hidden: true
      },
      {
        path: 'updateMenu',
        name: 'updateMenu',
        component: () => import('@/views/ums/menu/update'),
        meta: {title: '修改菜单'},
        hidden: true
      },
      {
        path: 'resource',
        name: 'resource',
        component: () => import('@/views/ums/resource/index'),
        meta: {title: '资源列表', icon: 'ums-resource'}
      },
      {
        path: 'resourceCategory',
        name: 'resourceCategory',
        component: () => import('@/views/ums/resource/categoryList'),
        meta: {title: '资源分类'},
        hidden: true
      }
    ]
  },
  {path: '*', redirect: '/404', hidden: true}
]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({y: 0}),
  routes: constantRouterMap
})




// WEBPACK FOOTER //
// ./src/router/index.js